<template>
  <section class="section-advertiseWithUs">
    <div class="container-fluid">
      <div class="section-space-50"></div>

      <ul class="list-inline mx-auto fnb-page-List text-center">
        <li class="list-inline-item">
          <button
            class="btn rounded-10 font-weight-600 w-100"
            :class="
              tab1 ? 'btn-primary text-white' : 'btn-outline-primary text-white'
            "
            @click.prevent="showTabs('tab1')"
          >
            Careers
          </button>
        </li>
        <li class="list-inline-item">
          <button
            class="btn rounded-10 font-weight-600 w-100"
            :class="
              tab2 ? 'btn-primary text-white' : 'btn-outline-primary text-white'
            "
            @click.prevent="showTabs('tab2')"
          >
            Life at Miraj Cinemas
          </button>
        </li>
      </ul>

      <div class="section-space-50"></div>

      <!-- LIFE AT MIRAJ START -->
      <div v-if="tab2">
        <div class="container mb-5">
          <div class="section-header-title">Life at Miraj Cinemas</div>
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="my-4 my-md-5">
                <div v-html="life_at_miraj"></div>
              </div>
            </div>
            <!-- <div class="col-lg-6">
              <slick :options="aboutUsSlider">
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-1.1.jpeg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-2.1.jpeg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-3.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-4.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-5.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-6.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-7.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-8.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-9.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-10.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-11.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-12.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
                <div>
                  <img
                    src="../../assets/img/advertisingImages/image-13.jpg"
                    class="img-fluid w-100 rounded p-2 d-table"
                    alt
                  />
                </div>
              </slick>
            </div> -->
          </div>
        </div>
        <slick :options="testimonialSlider">
          <div
            v-for="(data, index) in employee_testimonials"
            :key="'Employee_testimonials_' + index"
          >
            <div class="testi-card">
              <div class="testi-img">
                <img
                  class="img-fluid"
                  src="http://uat.mirajcinemas.com/static/img/dummy.svg"
                  lazy="error"
                />
              </div>
              <div class="testi-content">
                <div v-html="data.extra_html_content"></div>
              </div>
              <!-- <div class="testi-content">
                <div>
                  <svg
                    width="35"
                    height="26"
                    viewBox="0 0 35 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.0264 25.487C8.30913 25.487 6.74516 24.9548 5.33453 23.8903C3.92389 22.7633 2.78924 21.3231 1.93059 19.5699C1.13328 17.8167 0.734619 16.0635 0.734619 14.3103C0.734619 10.7412 2.05326 7.82964 4.69054 5.57551C7.32782 3.25877 10.5478 1.53686 14.3503 0.409794C14.9023 0.159338 15.393 0.221954 15.8223 0.597641C16.2516 0.973329 16.4663 1.44294 16.4663 2.00647C16.4663 2.63262 16.1596 3.07092 15.5463 3.32138C12.909 4.32322 10.9464 5.5129 9.65844 6.89042C8.37046 8.20533 7.72648 9.80201 7.72648 11.6804C7.72648 12.7449 8.03314 13.6215 8.64646 14.3103C9.25978 14.9364 10.1184 15.6252 11.2224 16.3766C12.3264 17.1279 13.1544 17.8167 13.7064 18.4428C14.3197 19.069 14.6263 19.8517 14.6263 20.7909C14.6263 21.9806 14.1663 23.0763 13.2464 24.0782C12.3877 25.0174 11.3144 25.487 10.0264 25.487ZM28.4261 25.487C26.7088 25.487 25.1448 24.9548 23.7341 23.8903C22.3235 22.7633 21.1889 21.3231 20.3302 19.5699C19.5329 17.8167 19.1342 16.0635 19.1342 14.3103C19.1342 10.7412 20.4529 7.82964 23.0902 5.57551C25.7274 3.25877 28.9474 1.53686 32.75 0.409794C33.3019 0.159338 33.7926 0.221954 34.2219 0.597641C34.6513 0.973329 34.8659 1.44294 34.8659 2.00647C34.8659 2.63262 34.5593 3.07092 33.9459 3.32138C31.3087 4.32322 29.346 5.5129 28.0581 6.89042C26.7701 8.20533 26.1261 9.80201 26.1261 11.6804C26.1261 12.7449 26.4328 13.6215 27.0461 14.3103C27.6594 14.9364 28.518 15.6252 29.622 16.3766C30.726 17.1279 31.554 17.8167 32.106 18.4428C32.7193 19.069 33.026 19.8517 33.026 20.7909C33.026 21.9806 32.566 23.0763 31.646 24.0782C30.7873 25.0174 29.714 25.487 28.4261 25.487Z"
                      fill="#bc7f6b"
                    />
                  </svg>
                  <div class="">
                    <p class="text-left testi-content-desc">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to
                    </p>
                  </div>
                  <div style="text-align: right">
                    <svg
                      style="transform: rotate(180deg)"
                      width="35"
                      height="26"
                      viewBox="0 0 35 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.0264 25.487C8.30913 25.487 6.74516 24.9548 5.33453 23.8903C3.92389 22.7633 2.78924 21.3231 1.93059 19.5699C1.13328 17.8167 0.734619 16.0635 0.734619 14.3103C0.734619 10.7412 2.05326 7.82964 4.69054 5.57551C7.32782 3.25877 10.5478 1.53686 14.3503 0.409794C14.9023 0.159338 15.393 0.221954 15.8223 0.597641C16.2516 0.973329 16.4663 1.44294 16.4663 2.00647C16.4663 2.63262 16.1596 3.07092 15.5463 3.32138C12.909 4.32322 10.9464 5.5129 9.65844 6.89042C8.37046 8.20533 7.72648 9.80201 7.72648 11.6804C7.72648 12.7449 8.03314 13.6215 8.64646 14.3103C9.25978 14.9364 10.1184 15.6252 11.2224 16.3766C12.3264 17.1279 13.1544 17.8167 13.7064 18.4428C14.3197 19.069 14.6263 19.8517 14.6263 20.7909C14.6263 21.9806 14.1663 23.0763 13.2464 24.0782C12.3877 25.0174 11.3144 25.487 10.0264 25.487ZM28.4261 25.487C26.7088 25.487 25.1448 24.9548 23.7341 23.8903C22.3235 22.7633 21.1889 21.3231 20.3302 19.5699C19.5329 17.8167 19.1342 16.0635 19.1342 14.3103C19.1342 10.7412 20.4529 7.82964 23.0902 5.57551C25.7274 3.25877 28.9474 1.53686 32.75 0.409794C33.3019 0.159338 33.7926 0.221954 34.2219 0.597641C34.6513 0.973329 34.8659 1.44294 34.8659 2.00647C34.8659 2.63262 34.5593 3.07092 33.9459 3.32138C31.3087 4.32322 29.346 5.5129 28.0581 6.89042C26.7701 8.20533 26.1261 9.80201 26.1261 11.6804C26.1261 12.7449 26.4328 13.6215 27.0461 14.3103C27.6594 14.9364 28.518 15.6252 29.622 16.3766C30.726 17.1279 31.554 17.8167 32.106 18.4428C32.7193 19.069 33.026 19.8517 33.026 20.7909C33.026 21.9806 32.566 23.0763 31.646 24.0782C30.7873 25.0174 29.714 25.487 28.4261 25.487Z"
                        fill="#bc7f6b"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h5>- User One</h5>
                </div>
              </div> -->
            </div>
          </div>
        </slick>
      </div>
      <!-- LIFE AT MIRAJ END -->

      <!-- Careers START -->
      <div v-if="tab1">
        <CareerComponent />
      </div>
      <!-- Careers END -->

      <!-- WHY MIRAJ CINEMAS START -->
      <div v-if="tab3" class="mt-5">
        <slick :options="testimonialSlider">
          <div v-for="(data, index) in 10" :key="index">
            <div class="testi-card">
              <div class="testi-img">
                <img
                  class="img-fluid"
                  src="http://uat.mirajcinemas.com/static/img/dummy.svg"
                  lazy="error"
                />
              </div>
              <div class="testi-content">
                <div>
                  <svg
                    width="35"
                    height="26"
                    viewBox="0 0 35 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.0264 25.487C8.30913 25.487 6.74516 24.9548 5.33453 23.8903C3.92389 22.7633 2.78924 21.3231 1.93059 19.5699C1.13328 17.8167 0.734619 16.0635 0.734619 14.3103C0.734619 10.7412 2.05326 7.82964 4.69054 5.57551C7.32782 3.25877 10.5478 1.53686 14.3503 0.409794C14.9023 0.159338 15.393 0.221954 15.8223 0.597641C16.2516 0.973329 16.4663 1.44294 16.4663 2.00647C16.4663 2.63262 16.1596 3.07092 15.5463 3.32138C12.909 4.32322 10.9464 5.5129 9.65844 6.89042C8.37046 8.20533 7.72648 9.80201 7.72648 11.6804C7.72648 12.7449 8.03314 13.6215 8.64646 14.3103C9.25978 14.9364 10.1184 15.6252 11.2224 16.3766C12.3264 17.1279 13.1544 17.8167 13.7064 18.4428C14.3197 19.069 14.6263 19.8517 14.6263 20.7909C14.6263 21.9806 14.1663 23.0763 13.2464 24.0782C12.3877 25.0174 11.3144 25.487 10.0264 25.487ZM28.4261 25.487C26.7088 25.487 25.1448 24.9548 23.7341 23.8903C22.3235 22.7633 21.1889 21.3231 20.3302 19.5699C19.5329 17.8167 19.1342 16.0635 19.1342 14.3103C19.1342 10.7412 20.4529 7.82964 23.0902 5.57551C25.7274 3.25877 28.9474 1.53686 32.75 0.409794C33.3019 0.159338 33.7926 0.221954 34.2219 0.597641C34.6513 0.973329 34.8659 1.44294 34.8659 2.00647C34.8659 2.63262 34.5593 3.07092 33.9459 3.32138C31.3087 4.32322 29.346 5.5129 28.0581 6.89042C26.7701 8.20533 26.1261 9.80201 26.1261 11.6804C26.1261 12.7449 26.4328 13.6215 27.0461 14.3103C27.6594 14.9364 28.518 15.6252 29.622 16.3766C30.726 17.1279 31.554 17.8167 32.106 18.4428C32.7193 19.069 33.026 19.8517 33.026 20.7909C33.026 21.9806 32.566 23.0763 31.646 24.0782C30.7873 25.0174 29.714 25.487 28.4261 25.487Z"
                      fill="#bc7f6b"
                    />
                  </svg>
                  <div class="">
                    <!---->
                    <p class="text-left testi-content-desc">
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to
                    </p>
                  </div>
                  <div style="text-align: right">
                    <svg
                      style="transform: rotate(180deg)"
                      width="35"
                      height="26"
                      viewBox="0 0 35 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.0264 25.487C8.30913 25.487 6.74516 24.9548 5.33453 23.8903C3.92389 22.7633 2.78924 21.3231 1.93059 19.5699C1.13328 17.8167 0.734619 16.0635 0.734619 14.3103C0.734619 10.7412 2.05326 7.82964 4.69054 5.57551C7.32782 3.25877 10.5478 1.53686 14.3503 0.409794C14.9023 0.159338 15.393 0.221954 15.8223 0.597641C16.2516 0.973329 16.4663 1.44294 16.4663 2.00647C16.4663 2.63262 16.1596 3.07092 15.5463 3.32138C12.909 4.32322 10.9464 5.5129 9.65844 6.89042C8.37046 8.20533 7.72648 9.80201 7.72648 11.6804C7.72648 12.7449 8.03314 13.6215 8.64646 14.3103C9.25978 14.9364 10.1184 15.6252 11.2224 16.3766C12.3264 17.1279 13.1544 17.8167 13.7064 18.4428C14.3197 19.069 14.6263 19.8517 14.6263 20.7909C14.6263 21.9806 14.1663 23.0763 13.2464 24.0782C12.3877 25.0174 11.3144 25.487 10.0264 25.487ZM28.4261 25.487C26.7088 25.487 25.1448 24.9548 23.7341 23.8903C22.3235 22.7633 21.1889 21.3231 20.3302 19.5699C19.5329 17.8167 19.1342 16.0635 19.1342 14.3103C19.1342 10.7412 20.4529 7.82964 23.0902 5.57551C25.7274 3.25877 28.9474 1.53686 32.75 0.409794C33.3019 0.159338 33.7926 0.221954 34.2219 0.597641C34.6513 0.973329 34.8659 1.44294 34.8659 2.00647C34.8659 2.63262 34.5593 3.07092 33.9459 3.32138C31.3087 4.32322 29.346 5.5129 28.0581 6.89042C26.7701 8.20533 26.1261 9.80201 26.1261 11.6804C26.1261 12.7449 26.4328 13.6215 27.0461 14.3103C27.6594 14.9364 28.518 15.6252 29.622 16.3766C30.726 17.1279 31.554 17.8167 32.106 18.4428C32.7193 19.069 33.026 19.8517 33.026 20.7909C33.026 21.9806 32.566 23.0763 31.646 24.0782C30.7873 25.0174 29.714 25.487 28.4261 25.487Z"
                        fill="#bc7f6b"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h5>- User One</h5>
                </div>
              </div>
            </div>
          </div>
        </slick>
      </div>
      <!-- WHY MIRAJ CINEMAS END -->

      <!-- ADVERTISING START -->
      <div v-if="tab4">
        <div class="row">
          <div class="col-12">
            <div class="section-header-title">Advertising</div>

            <h5 class="font-weight-bold">On-screen Advertising:</h5>
            <p>
              On-screen advertising includes digital commercials or static
              slides that are played in the audi before the movie begins or
              during the interval.
            </p>

            <p>
              The average duration for a digital commercial is 30 secs. 10 secs
              for a static slide.
            </p>

            <h5 class="font-weight-bold">Off-screen Advertising:</h5>

            <!-- ACCORDION VIEW START-->
            <div role="tablist" class="tl-accordion">
              <b-card no-body class="mb-3">
                <b-card-header
                  header-tag="header"
                  class="p-3 tl-accordion-header cursor-pointer"
                  role="tab"
                >
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                    v-b-toggle.accordion-1
                  >
                    <div>Cinepass(Box Office), Outdoor &amp; Main Entrance</div>

                    <div>
                      <img src="@/assets/img/icons/down-arrow.svg" alt />
                      <!-- <img src="@/assets/img/icons/up-arrow.svg" alt /> -->
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  id="accordion-1"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <!-- visible -->
                  <b-card-body>
                    <b-card-text>
                      <div class="row">
                        <div class="col-12 col-md-7">
                          <ol class="pl-3 pl-md-4 pl-lg-5">
                            <li>Branding on box-office panels</li>
                            <li>Sampling of Posters at the box-office</li>
                            <li>Tent cards at the box-office</li>
                            <li>Glow boxes at the box-office</li>
                            <li>Digital plasmas posters at the box-office</li>
                            <li>Leaflet distribution</li>
                            <li>Ticket jackets</li>
                            <li>Products from box-office</li>
                            <li>Discount vouchers distribution</li>
                            <li>Branding on cue managers</li>
                            <li>Standee display at the box-office</li>
                            <li>Branding on Quick Tix Machines</li>
                            <li>Contest form distribution</li>
                            <li>Counter branding on box-office glass</li>
                            <li>Outdoors on main facades</li>
                            <li>Product displays on facades</li>
                            <li>Branding on facade panels</li>
                            <li>Cutouts on facades</li>
                            <li>Contra vision branding on main entry glass</li>
                            <li>Standees at the main entry</li>
                            <li>Gate arch at the main entry</li>
                            <li>Branding on entrance podium</li>
                            <li>Stickers on glass doors</li>
                            <li>Translites at the main entrance</li>
                            <li>Sampling of products from the main entry</li>
                            <li>Branding on ladies frisking zone</li>
                            <li>Branding on HHMD Machines</li>
                            <li>Branding on the uniform of security staff</li>
                            <li>Branding carpet at main entry passage</li>
                            <li>
                              Sample distribution from ladies frisking zone
                            </li>
                          </ol>
                        </div>

                        <div class="col-12 col-md-5">
                          <img
                            v-lazy="IMAGE_URL + image_1"
                            class="img-fluid w-100"
                            alt=""
                          />
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3">
                <b-card-header
                  header-tag="header"
                  class="p-3 tl-accordion-header cursor-pointer"
                  role="tab"
                >
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                    v-b-toggle.accordion-2
                  >
                    <div>In-Audi Branding</div>
                    <div>
                      <img src="@/assets/img/icons/down-arrow.svg" alt />
                      <!-- <img src="@/assets/img/icons/up-arrow.svg" alt /> -->
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <div class="row">
                        <div class="col-12 col-md-7">
                          <ol class="pl-3 pl-md-4 pl-lg-5">
                            <li>Branding on seats</li>
                            <li>Lucky seat branding</li>
                            <li>Vouchers under audi seats</li>
                            <li>Branding on audi stairs</li>
                            <li>Lucky seat announcements</li>
                          </ol>
                        </div>

                        <div class="col-12 col-md-5">
                          <img
                            v-lazy="IMAGE_URL + image_2"
                            class="img-fluid w-100"
                            alt=""
                          />
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3">
                <b-card-header
                  header-tag="header"
                  class="p-3 tl-accordion-header cursor-pointer"
                  role="tab"
                >
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                    v-b-toggle.accordion-3
                  >
                    <div>Lobby Branding</div>

                    <div>
                      <img src="@/assets/img/icons/down-arrow.svg" alt />
                      <!-- <img src="@/assets/img/icons/up-arrow.svg" alt /> -->
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  id="accordion-3"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <div class="row">
                        <div class="col-12 col-md-7">
                          <ol class="pl-3 pl-md-4 pl-lg-5">
                            <li>Standee in the main lobby</li>
                            <li>Translites in the main lobby</li>
                            <li>Backlits in the main lobby</li>
                            <li>Pillar branding in the main lobby</li>
                            <li>Big wall brandings in lobby</li>
                            <li>Posters on digital plasmas</li>
                            <li>Promos on digital plasmas</li>
                            <li>Kiosk promotion in lobby</li>
                            <li>Data generation activity with promoters</li>
                            <li>Product display in the main lobby</li>
                            <li>Sampling of products</li>
                            <li>Cutout displays in the lobby</li>
                            <li>Audi door branding</li>
                            <li>
                              Wall branding with plasma screens playing
                              exclusive clips of brand
                            </li>
                            <li>Floor stickers</li>
                            <li>Frames in lobby areas</li>
                            <li>Wall backlit branding</li>
                            <li>Gate arch at audi entrance</li>
                          </ol>
                        </div>

                        <div class="col-12 col-md-5">
                          <img
                            v-lazy="IMAGE_URL + image_3"
                            class="img-fluid w-100"
                            alt=""
                          />
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3">
                <b-card-header
                  header-tag="header"
                  class="p-3 tl-accordion-header cursor-pointer"
                  role="tab"
                >
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                    v-b-toggle.accordion-4
                  >
                    <div>Washroom Branding</div>

                    <div>
                      <img src="@/assets/img/icons/down-arrow.svg" alt />
                      <!-- <img src="@/assets/img/icons/up-arrow.svg" alt /> -->
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  id="accordion-4"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <div class="row">
                        <div class="col-12 col-md-7">
                          <ol class="pl-3 pl-md-4 pl-lg-5">
                            <li>Branding on washroom doors</li>
                            <li>Branding on washroom mirrors</li>
                            <li>Stickers on urinals in gents washrooms</li>
                            <li>Branding on tissue dispensers</li>
                            <li>Posters in frames installed at</li>
                            <li>the back of cubicle doors</li>
                            <li>Sanitized strips branding</li>
                            <li>Branding on toilet roll dispensers</li>
                            <li>Stickers on washroom panels</li>
                          </ol>
                        </div>

                        <div class="col-12 col-md-5">
                          <img
                            v-lazy="IMAGE_URL + image_4"
                            class="img-fluid w-100"
                            alt=""
                          />
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3">
                <b-card-header
                  header-tag="header"
                  class="p-3 tl-accordion-header cursor-pointer"
                  role="tab"
                >
                  <div
                    class="
                      w-100
                      d-flex
                      align-items-center
                      justify-content-between
                    "
                    v-b-toggle.accordion-5
                  >
                    <div>Popcorner (F&B counter)</div>

                    <div>
                      <img src="@/assets/img/icons/down-arrow.svg" alt />
                      <!-- <img src="@/assets/img/icons/up-arrow.svg" alt /> -->
                    </div>
                  </div>
                </b-card-header>
                <b-collapse
                  id="accordion-5"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <div class="row">
                        <div class="col-12 col-md-7">
                          <ol class="pl-3 pl-md-4 pl-lg-5">
                            <li>Danglers</li>
                            <li>Tiltalkers</li>
                            <li>Popcorn tub branding</li>
                            <li>Drop box branding</li>
                            <li>Staff uniform branding</li>
                            <li>Branding on candy panels</li>
                            <li>Branding on candy TFTs</li>
                            <li>Standees at Concession Counters</li>
                            <li>Product sampling from Concession Counters</li>
                            <li>Branding on candy digital plasmas</li>
                            <li>Menu board branding</li>
                            <li>Branding combos</li>
                            <li>Glow box at candy bar</li>
                            <li>Cash tray branding</li>
                          </ol>
                        </div>

                        <div class="col-12 col-md-5">
                          <img
                            v-lazy="IMAGE_URL + image_5"
                            class="img-fluid w-100"
                            alt=""
                          />
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!-- <b-card no-body class="mb-3">
                  <b-card-header
                    header-tag="header"
                    class="p-3 tl-accordion-header cursor-pointer"
                    role="tab"
                  >
                    <div
                      class="w-100 d-flex align-items-center justify-content-between"
                      v-b-toggle.accordion-6
                    >
                      <div>Main Entrance</div>
  
                      <div>
                        <img src="@/assets/img/icons/down-arrow.svg" alt />
                        <img src="@/assets/img/icons/up-arrow.svg" alt />
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse
                    id="accordion-6"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div class="row">
                          <div class="col-12 col-md-7">
                            <ol class="pl-3 pl-md-4 pl-lg-5">
                              <li>Contra vision branding on main entry glass</li>
                              <li>Standees at the main entry</li>
                              <li>Gate arch at the main entry</li>
                              <li>Branding on entrance podium</li>
                              <li>Stickers on glass doors</li>
                              <li>Translites at the main entrance</li>
                              <li>Sampling of products from the main entry</li>
                              <li>Branding on ladies frisking zone</li>
                              <li>Branding on HHMD Machines</li>
                              <li>Branding on the uniform of security staff</li>
                              <li>Branding carpet at main entry passage</li>
                              <li>
                                Sample distribution from ladies frisking zone
                              </li>
                            </ol>
                          </div>
  
                          <div class="col-12 col-md-5">
                            <img
                              v-lazy="IMAGE_URL + image_6"
                              class="img-fluid w-100 h-100"
                              alt=""
                            />
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card> -->
            </div>
            <!-- ACCORDION VIEW END-->
          </div>
        </div>
      </div>
      <!-- ADVERTISING US END -->

      <div class="section-space-50"></div>
    </div>

    <!-- F&B APPLICATION SUBMITTED MODAL -->
    <b-modal
      ref="alertPopup"
      id="alertPopup"
      title="Request submitted"
      hide-footer
    >
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row my-4">
              <div class="col-12 text-center">
                <img src="@/assets/img/icons/check-icon.svg" alt="Success" />
              </div>
              <div class="col-12 text-center my-4">
                <p>
                  Your request for advertising was submitted successfully.
                  <br />We will get in touch with you soon!
                </p>
              </div>
              <div class="col-12">
                <button
                  class="btn btn-primary w-100"
                  @click="$bvModal.hide('alertPopup')"
                >
                  DONE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { ADVERTISE_SUBMIT_EMAIL, IMAGEURL } from "@/config";
import CareerComponent from "@/components/pages/careers.vue";
import MasterService from "@/apiServices/MasterService";
import ExtrasService from "@/apiServices/ExtrasService";

export default {
  components: {
    CareerComponent,
  },
  data() {
    return {
      employee_testimonials: [],
      life_at_miraj: "",
      imgArray: [{ src: `` }],
      IMAGE_URL: IMAGEURL,
      image_1: null,
      image_2: null,
      image_3: null,
      image_4: null,
      image_5: null,
      image_6: null,

      aboutUsSlider: {
        dots: false,
        arrows: true,
        slidesToShow: 1,
      },
      testimonialSlider: {
        dots: true,
        arrows: false,
        slidesToShow: 3,
      },
      aboutUsSliderNew: {
        dots: false,
        arrows: true,
        slidesToShow: 1,
      },
      tab1: false,
      tab2: false,
      tab3: true,
      tab4: false,
    };
  },
  computed: {
    ...mapGetters(["getLoggedUser", "getIsUserLogged"]),
  },
  methods: {
    showTabs(value) {
      if (value === "tab1") {
        this.tab1 = true;
        this.tab2 = false;
        this.tab3 = false;
        this.tab4 = false;
      } else if (value === "tab2") {
        this.tab1 = false;
        this.tab2 = true;
        this.tab3 = false;
        this.tab4 = false;
      } else if (value === "tab3") {
        this.tab1 = false;
        this.tab2 = false;
        this.tab3 = true;
        this.tab4 = false;
      } else if (value === "tab4") {
        this.tab1 = false;
        this.tab2 = false;
        this.tab3 = false;
        this.tab4 = true;
      }
    },
    async getPageImages() {
      const { data } = await MasterService.GetPageImages({
        page_code: "advertise_with_us",
      });
      if (data && data.status) {
        const {
          image_path_1,
          image_path_2,
          image_path_3,
          image_path_4,
          image_path_5,
          image_path_6,
        } = data.data;
        this.image_1 = image_path_1;
        this.image_2 = image_path_2;
        this.image_3 = image_path_3;
        this.image_4 = image_path_4;
        this.image_5 = image_path_5;
        this.image_6 = image_path_6;
      }
    },
    async getEmployeeTestimonials() {
      try {
        const response = await ExtrasService.getEmployeeTestimonials();
        if (response.data.status) {
          this.employee_testimonials = response.data.data;
        }
      } catch (err) {
        console.log("Error in getting  ", err);
      }
    },
    async getLifeAtMiraj() {
      try {
        const response = await ExtrasService.getLifeAtMiraj();
        if (response.data.status) {
          this.life_at_miraj = response.data.data.extra_html_content;
        }
      } catch (err) {
        console.log("Error in getting life at miraj html ", err);
      }
    },
  },
  beforeMount() {
    this.getPageImages();
    this.getLifeAtMiraj();
    this.getEmployeeTestimonials();
    this.showTabs(`tab1`);
  },
};
</script>
<style scoped>
.testi-card {
  display: grid;
  grid-template-columns: 20% 70%;
  grid-column-gap: 20px;
  background: #151515;
  padding: 20px;
  border-radius: 08px;
  margin: 20px;
}
.testi-content-desc {
  padding-left: 10px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LifeMirajCinemas.vue